import axios from 'lib/axios';

const getAllEvents = async ({serviceId,from,to}) => {
  const { data } = await axios.get(`/customer/event?serviceId=${serviceId}&from=${from}&to=${to}`);
  return data;
};

const getMyEvents = async () => {
  const { data } = await axios.get(`/customer/me/event`);
  return data;
};

const getEventById = async (id) => {
  const { data } = await axios.get(`/customer/event/${id}`);
  return data;
};

const createEvent = async(value) =>{
  const { data } = await axios.post('/customer/event/', value);
  return data;
}

export { getAllEvents, getEventById, createEvent, getMyEvents };
